import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

export const ProOnlyGate = ({
  title = 'Función exclusiva para el plan PRO',
  message = 'Esta opción no está disponible en tu plan actual.',
  valueContext,
}) => {
  // El mensaje de valor (lo que el usuario puede hacer) es el texto grande;
  // el aviso de restricción (title + message) pasa a texto chico debajo.
  // Sin valueContext (fallback), title asume el rol de encabezado grande.
  const headline = valueContext || title;

  return (
    <div className="max-w-2xl mx-auto py-16" data-testid="pro-only-gate">
      <Card className="border text-center">
        <CardContent className="p-10 flex flex-col items-center">
          <div className="w-14 h-14 rounded-xl bg-[#0F172A] flex items-center justify-center mb-6">
            <Lock className="w-7 h-7 text-white" />
          </div>
          <h2 className="text-2xl font-semibold text-[#0F172A] font-['Manrope']" data-testid="pro-only-gate-headline">
            {headline}
          </h2>
          <div className="mt-4 space-y-1">
            {valueContext && (
              <p className="text-sm font-medium text-muted-foreground" data-testid="pro-only-gate-title">
                {title}
              </p>
            )}
            <p className="text-sm text-muted-foreground" data-testid="pro-only-gate-message">
              {message}
            </p>
          </div>
          <Button asChild className="mt-8" data-testid="pro-only-gate-upgrade-btn">
            <Link to="/precios">Actualizar plan</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
